module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('nav', {
    staticClass: "navbar-default navbar-static-side",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "sidebar-collapse"
  }, [_c('ul', {
    staticClass: "nav metismenu",
    attrs: {
      "id": "side-menu"
    }
  }, [_c('li', {
    class: _vm.currPage == 'all' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/all"
    }
  }, [_c('i', {
    staticClass: "fa fa-sun-o"
  }), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("All")])])], 1), _c('li', {
    class: _vm.currPage == 'condo' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/condo"
    }
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  }), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Condo")]), _c('i', {
    staticClass: "fa arrow"
  })]), _c('ul', {
    staticClass: "nav nav-second-level"
  }, [_c('li', {
    class: _vm.$route.path.split('/')[2] == 'sale' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/condo/sale"
    }
  }, [_vm._v("Sale")])], 1), _c('li', {
    class: _vm.$route.path.split('/')[2] == 'rent' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/condo/rent"
    }
  }, [_vm._v("Rent")])], 1), (_vm.$ls.get('user').role_name == 'Super Admin') ? _c('li', {
    class: _vm.$route.path.split('/')[2] == 'name' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/condo/name"
    }
  }, [_vm._v("Project Name")])], 1) : _vm._e()])], 1), _c('li', {
    class: _vm.currPage == 'house' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/house"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("House")]), _c('i', {
    staticClass: "fa arrow"
  })]), _c('ul', {
    staticClass: "nav nav-second-level"
  }, [_c('li', {
    class: _vm.$route.path.split('/')[2] == 'sale' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/house/sale"
    }
  }, [_vm._v("Sale")])], 1), _c('li', {
    class: _vm.$route.path.split('/')[2] == 'rent' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/house/rent"
    }
  }, [_vm._v("Rent")])], 1)])], 1), _c('li', {
    class: _vm.currPage == 'townhouse' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/townhouse"
    }
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Townhouse")]), _c('i', {
    staticClass: "fa arrow"
  })]), _c('ul', {
    staticClass: "nav nav-second-level"
  }, [_c('li', {
    class: _vm.$route.path.split('/')[2] == 'sale' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/townhouse/sale"
    }
  }, [_vm._v("Sale")])], 1), _c('li', {
    class: _vm.$route.path.split('/')[2] == 'rent' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/townhouse/rent"
    }
  }, [_vm._v("Rent")])], 1)])], 1), _c('li', {
    class: _vm.currPage == 'land' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/land"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-signs"
  }), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Land")]), _c('i', {
    staticClass: "fa arrow"
  })]), _c('ul', {
    staticClass: "nav nav-second-level"
  }, [_c('li', {
    class: _vm.$route.path.split('/')[2] == 'sale' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/land/sale"
    }
  }, [_vm._v("Sale")])], 1), _c('li', {
    class: _vm.$route.path.split('/')[2] == 'rent' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/land/rent"
    }
  }, [_vm._v("Rent")])], 1)])], 1), _c('li', {
    class: _vm.currPage == 'building' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/building"
    }
  }, [_c('i', {
    staticClass: "fa fa-building-o"
  }), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Building")]), _c('i', {
    staticClass: "fa arrow"
  })]), _c('ul', {
    staticClass: "nav nav-second-level"
  }, [_c('li', {
    class: _vm.$route.path.split('/')[2] == 'sale' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/building/sale"
    }
  }, [_vm._v("Sale")])], 1), _c('li', {
    class: _vm.$route.path.split('/')[2] == 'rent' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/building/rent"
    }
  }, [_vm._v("Rent")])], 1)])], 1), (_vm.$ls.get('user').role_id == '1') ? _c('li', {
    class: _vm.currPage == 'users' ? 'active' : ''
  }, [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', {
    staticClass: "nav-label"
  }, [_vm._v("Users")])])], 1) : _vm._e()])])]), _c('div', {
    staticClass: "gray-bg dashbard-1",
    attrs: {
      "id": "page-wrapper"
    }
  }, [_c('div', {
    staticClass: "row border-bottom"
  }, [_c('div', {
    staticClass: "navbar navbar-static-top",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-minimalize minimalize-styl-2 btn btn-primary",
    on: {
      "click": _vm.toggleMiniNavbar
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])]), _c('ul', {
    staticClass: "nav navbar-top-links navbar-right"
  }, [_c('li', [_c('span', {
    staticClass: "m-r-sm text-muted"
  }, [_vm._v(_vm._s(_vm.$ls.get('user').username) + " (" + _vm._s(_vm.$ls.get('user').role_name) + ")")])]), _c('li', [_c('router-link', {
    attrs: {
      "to": "/logout"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Log out")])], 1)])])]), _c('div', {
    staticClass: "row wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "col-lg-10"
  }, [_c('h2', [_vm._v(_vm._s(_vm.currPage) + " Management")])])]), _c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-268ee472","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = 405
// module chunks = 3